
import {Vue, Prop, Component, Watch } from 'vue-property-decorator'
import Destination from './Passenger/models/Destination';
@Component({
    components: {

    }
})
export default class DestinationMultiSelect extends Vue {

  @Prop({ default: null }) organizationId: string | null;
  @Prop({ default: () => []}) value: number[];
  @Prop({ default: null}) selectAllValue: number | null;

  get destinationIds(): number[] {
    return this.value;
  }

  set destinationIds(newValue: number[]) {
    this.$emit('input', newValue);
  }

  get destinations(): Destination[] {
    const destinations = this.getDestinationsFromStore();
    if (this.selectAllValue !== null) {
      destinations.unshift({ id: this.selectAllValue, alias: this.$t('generic.all'), movitInstanceName: '' } as Destination);
    }
    return destinations;
  }

  getDestinationsFromStore(): Destination[] {
    if (this.organizationId) {
      return (this.$store.state.destination.destinations as Destination[]).filter(d => d.organizationId === this.organizationId);
    }
    return this.$store.state.destination.destinations as Destination[];

  }
}
